<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-28 15:02:14
 * @ Modified by: Your name
 * @ Modified time: 2019-07-15 14:25:37
 * @ Description: 用户管理 弹窗
 -->

<template>
  <div class="dialog-wrapper">
    <el-form :model="dialogFormData" label-width="80px" :rules="rules"
      label-position="right" ref="dialogForm"
      v-loading="formLoading" class="dialog-form" :inline="true">
      <div class="flex">
        <el-form-item label="姓名" prop="userName">
          <el-input
            autocomplete="on"
            @input="changeEvent"
            size="small" v-model="dialogFormData.userName"
            placeholder="姓名" :disabled="type !== 'add'" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            @input="changeEvent"
            type='password' autocomplete="off"
            size="small" v-model="dialogFormData.password"
            placeholder="密码" clearable />
        </el-form-item>
      </div>
      <div class="flex">
        <el-form-item label="员工号" prop="loginName">
          <el-input
            @input="changeEvent"
            size="small" v-model="dialogFormData.loginName"
            placeholder="员工号" clearable/>
        </el-form-item>
        <el-form-item label="员工卡" prop="icCardNo">
          <el-input
            @input="changeEvent"
            size="small" v-model="dialogFormData.icCardNo"
            placeholder="员工卡" clearable/>
        </el-form-item>
      </div>
      <div class="flex">
        <el-form-item label="用户角色" prop="roleId">
          <el-select v-model="dialogFormData.roleId" multiple @change="changeEvent"
            clearable placeholder="请选择" size="small" filterable>
            <template v-for="item in roleList">
              <el-option
                :disabled="item.forbidden === 1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="userPhone">
          <el-input
            @input="changeEvent"
            size="small" v-model="dialogFormData.userPhone"
            placeholder="手机号" clearable />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import dialog from '../../mixins/dialog'
import { correctPhone, validatePWD } from '../../libs/utils/validCheck'

export default {
  mixins: [dialog],
  data() {
    return {
      USERTYPE: 2,
      FORBIDDENID: 1, // 禁用admin角色
      formLoading: false,
      dialogFormData: {
        userName: ' ',
        password: '',
        userPhone: '',
        roleId: [],
        userType: this.USERTYPE,
        loginName: '',
        disabledStatus: 0,
        icCardNo: ''
      },
      formData: {
        test: ''
      },
      rules: {
        userName: { required: true, validator: this.userNameCheck, message: '请输入姓名', trigger: 'change' },
        password: [{ required: true, validator: validatePWD, trigger: 'change' }],
        userPhone: [{ required: true, message: '请输入手机号', trigger: 'change' },
          { validator: correctPhone, trigger: 'blur' }
        ],
        roleId: { required: true, message: '请选择用户角色', trigger: 'change' },
        loginName: [{ required: true, message: '请输入员工号', trigger: 'change' },
          { validator: this.onlyNumber6, trigger: 'blur' }]
      }
    }
  },
  computed: {
    roleList() {
      return this.dic.roleList
    }
  },
  methods: {
    initDialogFormdata() { // 初始化弹窗数据
      const { editInitData } = this.dic
      this.dialogFormData = {
        userName: editInitData.userName,
        password: editInitData.password,
        userPhone: editInitData.userPhone,
        roleId: editInitData.roleId,
        userType: this.USERTYPE,
        uuid: editInitData.uuid,
        loginName: editInitData.loginName,
        icCardNo: editInitData.icCardNo
      }
    },
    onlyNumber6(rule, value, callback) {
      const valid =  /^[0-9]*$/.test(value)
      if (!valid) {
        callback(new Error('请输入数字'))
      } else {
        callback()
      }
    },
    userNameCheck(rule, value, callback) {
      if (value !== ' ') {
        callback()
      } else {
        callback(new Error('请输入姓名'))
      }
    },
    band16(rule, value, callback) {
      const valid = /[\da-fA-F]{8}/.test(value)
      if (valid) {
        callback()
      } else {
        callback(new Error('请输入8位16进制'))
      }
    },
    changeEvent() {
      this.$emit('changeEvent')
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-wrapper{
  padding: 0px 35px;
  .flex{
    display: flex;
    height: 55px;
    justify-content: space-between;
    .dialog-wrapper .el-form-item{
      text-align: left;
    }
    /deep/.el-form-item__content .el-input__inner{
      width: 215px;
    }
  }
}
</style>
